<template>
  <div class="hints-container" :class="{'left': conceptDetailsPanel !== null}">

    <transition>
      <div v-if="isHintVisible(Hints.COMMON_SELECT_AT_LEAST_4_HOPES)" class="basic-hint simple-hint">Select at least 4 hopes</div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.COMMON_HOPEFUL_FOR_MORE)" class="simple-hint lifted more-conferm">Hopeful for more?</div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.COMMON_THATS_IT)" class="simple-hint lifted thats-it">That’s it!</div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.DESKTOP_SCROLL_TO_EXPLORE_AND_SELECT_YOUR_HOPES)" class="simple-hint arrow-container">
        <div class="arrow el-icon-arrow-up arrow-left-1" />
        <div class="arrow el-icon-arrow-up arrow-left-2" />
        <div class="copy">Scroll to explore<br>and select your Hopes</div>
        <div class="arrow el-icon-arrow-down arrow-right-1" />
        <div class="arrow el-icon-arrow-down arrow-right-2" />
      </div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.DESKTOP_SCROLL_UP_TO_EXPLORE_THE_DATA)" @click="onScrollDownClick" class="simple-hint multiple-scroll-to-explore-hint position-left arrow-container">
        <div class="arrow el-icon-arrow-up arrow-left-1" />
        <div class="arrow el-icon-arrow-up arrow-left-2" />
        <div class="copy">Scroll up<br>to explore the data</div>
      </div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.DESKTOP_SCROLL_DOWN_TO_COMPARE_TO_OTHERS)" @click="onScrollUpClick" class="simple-hint multiple-scroll-to-explore-hint position-right arrow-container">
        <div class="arrow el-icon-arrow-down arrow-left-1" />
        <div class="arrow el-icon-arrow-down arrow-left-2" />
        <div class="copy">Scroll down<br>to compare to others</div>
      </div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.DESKTOP_CLICK_ON_A_PEBBLE_TO_EXPLORE_THE_DATA)" class="simple-hint">Click on a pebble to explore the data</div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.DESKTOP_SCROLL_DOWN_TO_GO_BACK)" @click="onScrollUpClick" class="simple-hint arrow-container" :class="{'multiple-scroll-to-explore-hint': conceptDetailsPanel === null, 'position-right': conceptDetailsPanel === null}">
        <div class="arrow el-icon-arrow-down arrow-left-1" />
        <div class="arrow el-icon-arrow-down arrow-left-2" />
        <div class="copy">Scroll down<br>to go back</div>
      </div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.DESKTOP_CLICK_AND_EXPLORE_OTHER_PEOPLES_HOPES)" class="simple-hint">Click and explore other people’s Hopes</div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.MOBILE_SELECT_YOUR_HOPES)" class="simple-hint">Select your hopes</div>
    </transition>

    <transition>
      <MobileDragHintWheel v-if="isHintVisible(Hints.MOBILE_WHEEL_ANIMATION)" />
    </transition>

    <transition>
      <div class="mobile-animation" v-if="isHintVisible(Hints.MOBILE_EXPLORE_THE_DATA_ANIMATION)">
        <MobileDragHint   />
        <span>Explore the data</span>
      </div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.MOBILE_TAP_ON_A_PEBBLE_TO_EXPLORE_THE_DATA)" class="simple-hint">Tap on a pebble to explore the data</div>
    </transition>

    <transition>
      <div class="mobile-animation" v-if="isHintVisible(Hints.MOBILE_SWIPE_DOWN_TO_GO_BACK_TO_YOUR_GROUPED_HOPES_ANIMATION)">
        <MobileDragHint direction="down" />
        <span>Swipe down to go back to your grouped Hopes</span>
      </div>
    </transition>

    <transition>
      <div class="mobile-animation" v-if="isHintVisible(Hints.MOBILE_EXPLORE_OTHER_PEOPLES_HOPES_ANIMATION)">
        <MobileDragHint direction="down" />
        <span>Explore other people’s Hopes!</span>
      </div>
    </transition>

    <transition>
      <div class="mobile-animation" v-if="isHintVisible(Hints.MOBILE_SWIPE_DOWN_TO_GO_BACK_ANIMATION)">
        <MobileDragHint direction="down" />
        <span>Swipe down to go back</span>
      </div>
    </transition>

    <transition>
      <div class="mobile-animation" v-if="isHintVisible(Hints.MOBILE_TAKE_A_LOOK_AT_OTHER_PEOPLES_HOPES)">
        <MobileDragHint direction="down" />
        <span>Take a look at other people’s Hopes!</span>
      </div>
    </transition>

    <transition>
      <div v-if="isHintVisible(Hints.MOBILE_TAP_AND_EXPLORE_OTHER_PEOPLE_HOPES)" class="simple-hint">Tap and explore other people’s Hopes</div>
    </transition>


    <transition>
      <div class="mobile-animation" v-if="isHintVisible(Hints.MOBILE_EXPLORE_THE_DATA_ANIMATION_RELATED)">
        <MobileDragHint />
        <span>Explore the data</span>
      </div>
    </transition>

  </div>
</template>

<script>
import Hints from '@/atoms/Hints'
import MobileDragHint from '@/atoms/MobileDragHint'
import ScrollToExploreHint from '@/atoms/ScrollToExploreHint'
import MobileDragHintWheel from '@/atoms/MobileDragHintWheel'

export default {
  name: 'HintsContainer',

  components: {
    MobileDragHint,
    ScrollToExploreHint,
    MobileDragHintWheel
  },

  props: {
    mode: {
      type: String,
      required: true
    },

    inactivityTime: {
      type: Number,
      required: true
    },

    selectedConcepts: {
      type: Array,
      required: true
    },

    selectedTotem: {
      required: true
    },

    confirmingConcept: {
      required: true
    },

    totems: {
      type: Array,
      required: true
    },

    conceptDetailsPanel: {
      require: true
    },

    multiTotem: {
      type: Number,
      required: true
    },

    explodeTotem: {
      type: Number,
      required: true
    },

    clickTarget: {
      required: true
    },

    totemReady: {
      type: Boolean,
      required: true
    },

    inactivityThreshold: {
      type: Number,
      required: false,
      default: 10
    }
  },

  data: function () {
    return {
      Hints,
      hasOpenedDetailsPanelOnce: false,
      visitedHints: {},
      dismissedHints: {}
    }
  },

  watch: {
    conceptDetailsPanel: function (value) {
      if (value !== null) this.hasOpenedDetailsPanelOnce = true
    },
    selectedTotem: function (value) {
      this.hasOpenedDetailsPanelOnce = false
    }
  },

  methods: {
    onScrollUpClick () {
      this.$emit('scroll:up')
    },

    onScrollDownClick () {
      this.$emit('scroll:down')
    },

    isHintVisible: function (hint) {
      let dynamicInactivityThreshold = this.dismissedHints[hint] === true ? this.inactivityThreshold : 0.5
      let isVisible = false
      switch (hint) {
        case Hints.COMMON_SELECT_AT_LEAST_4_HOPES:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length > 0 && this.selectedConcepts.length < 4
          break
        case Hints.COMMON_HOPEFUL_FOR_MORE:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length >= 4 && this.selectedConcepts.length < 10
          break
        case Hints.COMMON_THATS_IT:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length === 10
          break
        case Hints.DESKTOP_SCROLL_TO_EXPLORE_AND_SELECT_YOUR_HOPES:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length === 0 && !this.$root.platform.mobile
          break
        case Hints.DESKTOP_SCROLL_UP_TO_EXPLORE_THE_DATA:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && !this.$root.platform.mobile
          break
        case Hints.DESKTOP_SCROLL_DOWN_TO_COMPARE_TO_OTHERS:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && !this.$root.platform.mobile && this.selectedTotem === this.totems[0]
          break
        case Hints.DESKTOP_CLICK_ON_A_PEBBLE_TO_EXPLORE_THE_DATA:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && !this.$root.platform.mobile
          break
        case Hints.DESKTOP_SCROLL_DOWN_TO_GO_BACK:
          let isOnOtherTotem = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && !this.$root.platform.mobile && this.selectedTotem !== this.totems[0]
          let isPanelOpen = this.mode === 'totem' && this.conceptDetailsPanel !== null
          isVisible = (isOnOtherTotem || isPanelOpen) && !this.$root.platform.mobile
          break
        case Hints.DESKTOP_CLICK_AND_EXPLORE_OTHER_PEOPLES_HOPES:
          isVisible = this.mode === 'totem' && this.multiTotem === 1 && !this.$root.platform.mobile
          break
        case Hints.MOBILE_SELECT_YOUR_HOPES:
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.selectedConcepts.length === 0 && this.$root.platform.mobile
          break
        case Hints.MOBILE_WHEEL_ANIMATION:
          dynamicInactivityThreshold = this.dismissedHints[hint] === true ? this.inactivityThreshold : 5
          isVisible = !this.confirmingConcept && this.mode === 'wheel' && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile
          break
        case Hints.MOBILE_EXPLORE_THE_DATA_ANIMATION:
          dynamicInactivityThreshold = this.dismissedHints[hint] === true ? this.inactivityThreshold : 5
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile && !this.hasOpenedDetailsPanelOnce && this.totemReady && this.selectedTotem === this.totems[0]
          break
        case Hints.MOBILE_TAP_ON_A_PEBBLE_TO_EXPLORE_THE_DATA:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && this.$root.platform.mobile && !this.hasOpenedDetailsPanelOnce
          break
        case Hints.MOBILE_SWIPE_DOWN_TO_GO_BACK_TO_YOUR_GROUPED_HOPES_ANIMATION:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && this.selectedTotem === this.totems[0] && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.inactivityTime > dynamicInactivityThreshold
          break
        case Hints.MOBILE_EXPLORE_OTHER_PEOPLES_HOPES_ANIMATION:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.selectedTotem === this.totems[0]
          break
        case Hints.MOBILE_SWIPE_DOWN_TO_GO_BACK_ANIMATION:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 1 && this.conceptDetailsPanel === null && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.selectedTotem !== this.totems[0] && this.inactivityTime > dynamicInactivityThreshold
          break
        case Hints.MOBILE_TAKE_A_LOOK_AT_OTHER_PEOPLES_HOPES:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.conceptDetailsPanel === null && this.$root.platform.mobile && this.hasOpenedDetailsPanelOnce && this.selectedTotem !== this.totems[0] && this.inactivityTime > dynamicInactivityThreshold
          break
        case Hints.MOBILE_TAP_AND_EXPLORE_OTHER_PEOPLE_HOPES:
          isVisible = this.mode === 'totem' && this.multiTotem === 1 && this.$root.platform.mobile
          break
        case Hints.MOBILE_EXPLORE_THE_DATA_ANIMATION_RELATED:
          isVisible = this.mode === 'totem' && this.multiTotem === 0 && this.explodeTotem === 0 && this.inactivityTime > dynamicInactivityThreshold && this.$root.platform.mobile && !this.hasOpenedDetailsPanelOnce && this.totemReady && this.selectedTotem !== this.totems[0]
          break
      }
      if (isVisible) this.$set(this.visitedHints, hint, true)

      if (this.visitedHints[hint] === true && !isVisible) this.$set(this.dismissedHints, hint, true)

      return isVisible
    }
  }
}
</script>

<style scoped lang="scss">
@import 'variables';

.hints-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  user-select: none;

  transition: transform 0.5s $ease-in-out-quad;

  &.left {
    @include breakpoint(#{$bp-sm}px) {
      transform: translate(-25%, 0);
    }
  }
}

.simple-hint,
.mobile-animation span {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: $z-ui;
  color: $c-gray;
  font-size: 14px;
  letter-spacing: 1px;
  text-align: center;
  // min-width: 400px;
  bottom: 55px;
  min-width: 80%;
  box-sizing: border-box;

  &.lifted {
    bottom: 80px;
  }
  @include breakpoint(#{$bp-sm}px) {
    bottom: 60px;
    &.lifted {
      bottom: 60px;
    }
    font-size: 16px;
    min-width: auto;
    // text-transform: uppercase;
  }
}

.multiple-scroll-to-explore-hint {
  text-align: left;
  min-width: 238px;

  pointer-events: all;
  cursor: pointer;

  transition: color 0.3s $ease-in-out-quad;

  &:hover {
    color: #333;
  }
}

.arrow-container {
  bottom: 60px;
  padding-right: 60px;
  padding-left: 60px;
}

.arrow {
  position: absolute;
  top: 13px;
  transform: translate(0, -50%);
  font-size: 23px;
  font-weight: 400;
}

.arrow-left-1,
.arrow-left-2 {
  left: 0;
}

.arrow-right-1,
.arrow-right-2 {
  right: 0;
}

.arrow-left-2 {
  top: 21px;
  opacity: 0.5;
}
.arrow-right-2 {
  top: 21px;
  opacity: 0.5;
}

.position-left {
  left: 35%;
  padding-right: 0;
}
.position-right {
  left: 65%;
  padding-right: 0;
}

.simple-hint.basic-hint {
  bottom: 55px;
}

.simple-hint.more-conferm {
  bottom: 100px;
}

.simple-hint.thats-it {
  @include breakpoint(#{$bp-sm}px) {
    bottom: 100px;
  }
}

</style>



// WEBPACK FOOTER //
// src/atoms/HintsContainer.vue